import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api, { apiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

const LOGO = "https://customer-assets-jt897jd0.emergentagent.net/job_drive-smart-25/artifacts/vqfz3t07_ENFLEET%20by%20POMEN.png";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) {
      setError("Kata laluan tidak sepadan");
      return;
    }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
    } catch (err) {
      setError(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen relative bg-[#10056E] flex flex-col items-center justify-center p-6">
      <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
        <div className="absolute -top-32 -left-32 w-[500px] h-[500px] rounded-full bg-white/5 blur-3xl" />
        <div className="absolute -bottom-40 right-1/4 w-[550px] h-[550px] rounded-full bg-[#2a17a8]/40 blur-3xl" />
      </div>
      <div className="relative z-10 w-full max-w-md fade-up">
        <div className="flex justify-center mb-8">
          <img src={LOGO} alt="ENFLEET by POMEN" className="h-14 w-auto" />
        </div>
        <div className="bg-white rounded-2xl shadow-2xl p-7 sm:p-8" data-testid="reset-password-page">
          <h2 className="font-heading text-xl font-semibold tracking-tight mb-1">Set Semula Kata Laluan</h2>
          {done ? (
            <div className="space-y-4 mt-4">
              <p className="text-sm bg-green-50 border border-green-200 text-[#146c43] rounded-lg p-3" data-testid="reset-success-msg">
                Kata laluan berjaya ditetapkan semula. Sila log masuk dengan kata laluan baharu anda.
              </p>
              <Button className="w-full bg-[#10056E] hover:bg-[#2a17a8]" onClick={() => navigate("/login")} data-testid="reset-goto-login-btn">
                Pergi ke Log Masuk
              </Button>
            </div>
          ) : (
            <>
              <p className="text-sm text-muted-foreground mb-6">Masukkan kata laluan baharu anda (min. 6 aksara).</p>
              <form className="space-y-4" onSubmit={submit}>
                <div className="space-y-1.5">
                  <Label>Kata Laluan Baharu</Label>
                  <Input data-testid="reset-password-input" type="password" required minLength={6} value={password}
                    onChange={(e) => setPassword(e.target.value)} />
                </div>
                <div className="space-y-1.5">
                  <Label>Sahkan Kata Laluan</Label>
                  <Input data-testid="reset-confirm-input" type="password" required minLength={6} value={confirm}
                    onChange={(e) => setConfirm(e.target.value)} />
                </div>
                {error && <p className="text-sm text-[#DC3545]" data-testid="reset-error">{error}</p>}
                <Button type="submit" className="w-full bg-[#10056E] hover:bg-[#2a17a8]" disabled={busy || !token} data-testid="reset-submit-btn">
                  {busy ? "Menyimpan..." : "Tetapkan Kata Laluan"}
                </Button>
                {!token && <p className="text-xs text-[#DC3545]">Pautan tidak sah — tiada token ditemui.</p>}
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
